module.exports = __webpack_public_path__ + "static/img/7.802e1e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/7.jpg
// module id = oPnG
// module chunks = 16